import { api } from './client';
import type { ChatHistoryPage, ChatMessage, ReadReceipt, Uuid } from '../types/api';

export interface ListMessagesParams {
  beforeMessageId?: Uuid;
  limit?: number;
}

export async function listMessages(
  transactionId: Uuid,
  params: ListMessagesParams = {},
): Promise<ChatHistoryPage> {
  const { data } = await api.get<ChatHistoryPage>(`/transactions/${transactionId}/chat/messages`, {
    params,
  });
  return data;
}

export interface SendMessagePayload {
  body?: string;
  attachmentDocumentId?: Uuid;
  metadata?: Record<string, unknown>;
}

export async function sendMessage(
  transactionId: Uuid,
  payload: SendMessagePayload,
): Promise<ChatMessage> {
  const { data } = await api.post<ChatMessage>(
    `/transactions/${transactionId}/chat/messages`,
    payload,
  );
  return data;
}

export async function markRead(transactionId: Uuid, lastReadMessageId: Uuid): Promise<ReadReceipt> {
  const { data } = await api.post<ReadReceipt>(`/transactions/${transactionId}/chat/read`, {
    lastReadMessageId,
  });
  return data;
}

export async function getMyReceipt(transactionId: Uuid): Promise<ReadReceipt | { threadId: null }> {
  const { data } = await api.get<ReadReceipt | { threadId: null }>(
    `/transactions/${transactionId}/chat/read/me`,
  );
  return data;
}

export interface ThreadReceipts {
  receipts: ReadReceipt[];
}

// Every party's read cursor on this thread. Needed so the sender's UI
// can render a blue double-tick when the *other* side has read past a
// message — the per-user `getMyReceipt` only reveals the caller's cursor.
export async function listThreadReceipts(transactionId: Uuid): Promise<ThreadReceipts> {
  const { data } = await api.get<ThreadReceipts>(`/transactions/${transactionId}/chat/receipts`);
  return data;
}
